<div class="header py-2 px-5">
  <a routerLink="" class="nota" >
    <img class="logo" src="assets/images/logo.png">
    <span> Tanteturner</span>
  </a>
</div>
<router-outlet></router-outlet>
<div class="footer py-2 px-5">
  <a class="mx-2" href="https://www.youtube.com/channel/UCJIteNgrxzmmp4K78NCPzYA"><i class="fab fa-youtube fa-3x"></i></a>
  <a class="mx-2" href="https://twitter.com/Tanteturner1"><i class="fab fa-twitter fa-3x"></i></a>
  <a class="mx-2" href="https://www.twitch.tv/tanteturner_hd"><i class="fab fa-twitch fa-3x"></i></a>
  <a class="mx-2" href="https://discord.gg/GBmGnvC"><i class="fab fa-discord fa-3x"></i></a>
</div>

